import { FC } from 'react';
import { Content, GroupField } from '@prismicio/client';
import { Simplify } from '../../../../../prismicio-types';

import { StaticCard } from './components';
import styles from './staticCards.module.scss';

type Props = {
  cards: GroupField<Simplify<Content.BenefitsSliceStaticPrimaryCardsItem>>;
};

export const StaticCards: FC<Props> = ({ cards }) => {
  return (
    <ul className={styles.cards}>
      {cards.map((card, index) => (
        <StaticCard key={card.card_title} card={card} index={index} />
      ))}
    </ul>
  );
};
